import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../api";

export default function Validate() {
  const { code } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!code) return;
    api.get(`/contracts/validate/${code}`)
      .then((r) => setResult(r.data))
      .catch(() => setResult({ valid: false, message: "Codigo no encontrado o invalido." }))
      .finally(() => setLoading(false));
  }, [code]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-orange-400 border-t-transparent" />
      </div>
    );
  }

  return (
    <section className="mx-auto max-w-lg rounded-2xl border border-orange-400/20 bg-black/20 p-8 text-center">
      {result?.valid ? (
        <>
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-green-500/20">
            <svg className="h-10 w-10 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-green-300">Contrato Valido</h1>
          <p className="mt-4 text-lg">Titular: <span className="font-semibold text-orange-300">{result.holder}</span></p>
          <p className="mt-2 text-sm text-orange-100/70">
            Fecha del evento: {new Date(result.eventDate).toLocaleDateString("es-MX", { day: "2-digit", month: "long", year: "numeric" })}
          </p>
          <p className="mt-1 text-sm text-orange-100/70">
            Valido hasta: {new Date(result.expirationDate).toLocaleDateString("es-MX", { day: "2-digit", month: "long", year: "numeric" })}
          </p>
        </>
      ) : (
        <>
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-red-500/20">
            <svg className="h-10 w-10 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-red-300">Contrato No Valido</h1>
          <p className="mt-4 text-sm text-orange-100/70">
            {result?.holder
              ? `El contrato de ${result.holder} ha expirado.`
              : "El codigo de validacion no corresponde a ningun contrato registrado."}
          </p>
        </>
      )}

      <p className="mt-8 text-xs text-orange-100/40">Codigo: {code}</p>
    </section>
  );
}
